<template>
  <Print v-if="isPrint" :form="form" :employeeList="employeeList" :board="board" />
  <div v-else>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" init-field-name="회사명" />

    <!--    재해자 정보(주소와 연락처는 직영근로자인 경우에만 기재)-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i>{{ $t('재해자 정보') }}</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('재해자 성명') }}</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_1 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_1" class="w-full flex-1"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('연령') }}</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_2 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_2" class="w-full flex-1"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('수급업체 확인여부') }}</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
        <vs-select v-model="form.inputB_4" autocomplete v-else :readonly="board.readonly" class="w-full flex-1">
          <vs-select-item text="확인" value="확인" />
          <vs-select-item text="미확인" value="미확인" />
        </vs-select>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('소속사') }}</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_3 }}</p>
        <CompanySelector :readonly="board.readonly" class="w-full flex-1" v-model="form.inputB_3" :placeholder="$t('선택')" @select="selectCompany"></CompanySelector>
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('주소') }}</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_5 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_5" class="w-full flex-1" placeholder="직영근로자인 경우에만 기재"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('연락처') }}</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_6 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_6" class="w-full flex-1" placeholder="직영근로자인 경우에만 기재"/>
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('사고일자') }}</div>
        <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_7 }}</p>
        <date-selector :readonly="board.readonly" v-else class="w-full flex-1" v-model="form.inputB_7" />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('사고시간') }}</div>
        <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_8 }}</p>
        <time-selector :readonly="board.readonly" v-else class="w-full flex-1" v-model="form.inputB_8" />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('재해장소') }}</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_9 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_9" class="w-full flex-1"/>
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('발생형태') }}</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_10 }}</p>
        <disaster-class-selector v-else class="w-full flex-1" :readonly="board.readonly" v-model="form.inputB_10" />
      </div>

      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">{{ $t('사고원인') }}</div>
        <ml-textarea class="flex-1 w-full" style="margin-bottom: 0" rows="5" v-model="form.inputB_11" :readonly="board.readonly" />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">{{ $t('재발방지조치') }}</div>
        <ml-textarea class="flex-1 w-full" style="margin-bottom: 0" rows="5" v-model="form.inputB_12" :readonly="board.readonly" />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">{{ $t('잔존 유해 위험 요인 조치 계획') }}</div>
        <ml-textarea class="flex-1 w-full" style="margin-bottom: 0" rows="5" v-model="form.inputB_13" :readonly="board.readonly" />
      </div>
    </div>

    <!-- 교육내용 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t('교육내용') }}</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer">
        <div>
          <div>{{ $t('교육구분') }}</div>
          <custom-option-selector :readonly="board.readonly" v-model="form.inputA_1" @change="changeTarget1" :options="diff" />
        </div>
        <div v-if="!!form.inputA_1 && 1 < diff[form.inputA_1.index].child.length" class="writeGridLineItem">
          <div>{{ $t('대상(작업명)') }}</div>
          <custom-option-selector
            :readonly="board.readonly"
            v-model="form.inputA_2"
            :options="diff[form.inputA_1.index].child"
            placeholder="1. 고압실 내 작업(잠함공법이나 그 밖의 압기공법으로 대기압을 넘는 기압인 작업실 또는 수갱 내부에서 하는 작업만 해당한다)"
            @change="changeTarget2"
          />
        </div>
        <div>
          <div>{{ $t('교육명') }}</div>
          <ml-input v-model="form.inputA_3" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>{{ $t('교육일') }}</div>
          <date-selector v-model="form.inputA_4" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t('교육시간') }}</div>
          <div class="time">
            <time-selector v-model="form.inputA_5" :readonly="board.readonly" />
            <p>~</p>
            <time-selector v-model="form.inputA_6" :readonly="board.readonly" />
          </div>
        </div>
        <div>
          <div>{{ $t('교육장소') }}</div>
          <ml-input v-model="form.inputA_7" :readonly="board.readonly" placeholder="입력필드" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>{{ $t('교육내용에 반영한 재해형태(필수)') }}</div>
          <disaster-class-selector :multiple="true" :readonly="board.readonly" :addData="['직접입력']" placeholder="입력필드" v-model="form.inputA_8" />
        </div>
        <div v-show="form.inputA_8.includes('직접입력')">
          <div>{{ $t('직접입력') }}</div>
          <ml-input v-model="form.inputA_17" :readonly="board.readonly" placeholder="입력필드" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t('교육 실시자 성명') }}</div>
          <ml-input v-model="form.inputA_9" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>{{ $t('교육 실시자 소속') }}</div>
          <ml-input v-model="form.inputA_10" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>{{ $t('교육 실시자 직책') }}</div>
          <ml-input v-model="form.inputA_11" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>{{ $t('교육 대상') }}</div>
          <ml-input v-model="form.inputA_12" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>{{ $t('교육 실시 인원') }}</div>
          <comma-input v-model="form.inputA_13" type="number" :readonly="board.readonly" placeholder="입력필드" />
          <p>명</p>
        </div>
        <div>
          <div>{{ $t('교육 미실시 인원') }}</div>
          <comma-input v-model="form.inputA_14" type="number" :readonly="board.readonly" />
          <p>명</p>
        </div>
        <div class="writeGridLineItem">
          <div>{{ $t('교육내용') }}</div>
          <ml-textarea rows="5" v-model="form.inputA_15" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>{{ $t('근로자 의견') }}</div>
          <ml-textarea rows="5" v-model="form.inputA_16" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 참석자 명단 -->
    <table-custom
      :controls="true"
      :multiple="true"
      :board="board"
      :is-print="isPrint"
      title="참석자 명단"
      :tableData="[
        { id: 'employee_id', title: 'ID(사번)', type: 'fixed-text', placeholder: '' },
        { id: 'com_name', title: '부서명', type: 'fixed-text', placeholder: '' },
        { id: 'employment_type', title: '직종', type: 'fixed-text', placeholder: '' },
        { id: 'full_name', title: '이름', type: 'fixed-text', placeholder: '' },
        { id: 'note', title: '비고', type: 'text', placeholder: '' },
      ]"
      :mobile="['target', 'name']"
      v-model="employeeList"
      class="mt-4"
      :button-add-name="'참석자 등록'"
      :custom-add-handler="true"
      :custom-remove-handler="true"
      @add-row="onClickAddEmployee"
      @remove-row="onClickRemoveEmployee"
    />

    <!-- 확인자 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t('확인자') }}</h5>
        </vs-col>
      </vs-row>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t('안전관리자') }}</div>
          <ml-input v-model="form.sign1.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t('서명') }}</div>
          <sign-field v-model="form.sign1.sign" :readonly="board.readonly" />
        </div>
        <div class="hidden xl:block"></div>
        <div>
          <div>{{ $t('관리책임자') }}</div>
          <ml-input v-model="form.sign2.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t('서명') }}</div>
          <sign-field v-model="form.sign2.sign" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module :gridCount="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <popup-search-employee-checkbox v-model="showPopup" :initSelectedEmployees="JSON.parse(JSON.stringify(employeeList))" @handleClickSelect="handleEmployeeSelect" />
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TimeSelector from "@/components/selector/TimeSelector";
import DateSelector from "@/components/selector/DateSelector";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import Print from "./Print.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelectorObject";
import diffData from "./DiffData";
import PopupSearchEmployeeCheckbox from "@/popup/PopupSearchEmployeeCheckbox.vue";
import TableCustom from "@/components/TableCustom.vue";
import SignField from "@/components/SignField.vue";

export default {
  components: {
    CompanySelector,
    Print,
    PhotoUploadGridModule,
    DisasterClassSelector,
    DateSelector,
    TimeSelector,
    FieldSelectModule,
    FileUploadModule,
    CustomOptionSelector,
    PopupSearchEmployeeCheckbox,
    TableCustom,
    SignField,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
        this.syncDiffSelection();
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;

        // 문서에는 종사자 ID 값만 보관되어 있다.
        // ID 값에 해당하는 종사자 목록을 불러오도록 한다
        this.initEmployeeList();

        // 교육 시간을 갱신한다
        this.updateEducationHours();

        this.$emit("input", value);
      },
    },
    /**
     * 종사자 목록이 갱신되면, form 내에는 ID 값만 추출해서 보관한다.
     * 종사자 정보 중에는 암호화되어 있는 데이터가 있기 때문에, 모든 정보를 보관하면 보안상 문제가 발생할 수 있다.
     * {id: 1, note: '비고'} 형식으로 변환한다
     */
    employeeList: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.selectedEmployees = value.map((item) => {
          return { id: item.id, note: item.note };
        });
      },
    },
  },
  created () {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
    this.syncDiffSelection();
  },
  data() {
    return {
      diff: diffData,
      showPopup: false,

      // 종사자 정보
      employeeList: [],

      form: {
        stdInfo: {},
        fileList: [],
        photoList: [{ placeholder: "재발방지 조치 사진" }, { placeholder: "재발방지 조치 사진" }],

        inputA_1: null,
        inputA_2: null,

        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: [],
        inputA_9: "",
        inputA_10: "",
        inputA_11: "",
        inputA_12: "",
        inputA_13: "",
        inputA_14: "",
        inputA_15: "",
        inputA_16: "",
        inputA_17: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",
        inputB_9: "",
        inputB_10: "",
        inputB_11: "",
        inputB_12: "",
        inputB_13: "",

        companyName: "",

        selectedEmployees: [],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
      },
    };
  },
  methods: {
    /**
     * 문서를 불러왔을 때 사용된다.
     * 문서에는 보안을 위해서, 종사자 ID 값만 보관되어 있다.
     * ID 값에 해당하는 종사자 목록을 불러오도록 한다
     */
    initEmployeeList() {
      // 문서에서 불러온 종사자 정보(id)가 있지만, 종사자 목록이 비어있는 경우
      if (this.form.selectedEmployees && this.form.selectedEmployees.length > 0 && this.employeeList.length === 0) {
        const page = 1;
        const perPage = this.form.selectedEmployees.length;
        const projectId = this.projectId;
        const ids = this.form.selectedEmployees.map((item) => item.id);

        const payload = { projectId, page, perPage, ids };

        this.$store.dispatch("employee/LOAD_EMPLOYEE_LIST", payload).then((result) => {
          if (result.data) {
            this.employeeList = result.data;

            // this.form.selectedEmployees 아이템의 id가 일치하는 this.employeeList 아이템에 note 값을 추가한다
            for (const item of this.form.selectedEmployees) {
              const index = this.employeeList.findIndex((employee) => employee.id === item.id);
              if (index > -1) {
                this.employeeList[index].com_name = this.employeeList[index].company.com_name;
                this.employeeList[index].note = item.note;
              }
            }
          }
        });
      }
    },

    // education_start_time 시각(10:00:00)으로부터 education_end_time 시각(16:00:00)까지 경과된 시간을 form.educationHours 에 저장한다
    updateEducationHours() {
      if (this.form.education_start_time && this.form.education_end_time) {
        const start = moment(this.form.education_start_time, "HH:mm:ss");
        const end = moment(this.form.education_end_time, "HH:mm:ss");
        const duration = moment.duration(end.diff(start));
        const hours = duration.asHours();

        // 만약 hours 값이 0보다 작다면 0으로 설정한다
        this.form.educationHours = hours < 0 ? 0 : hours;
      }
    },

    // == FORM ==
    selectCompany(value) {
      this.form.companyName = value.com_name;
    },
    // 저장된 교육구분/대상(작업명)은 목록 index 기준으로 복원되므로,
    // 목록이 개정되어도 key(우선) 또는 이름(value) 기준으로 index를 다시 맞춘다
    syncDiffSelection() {
      const savedType = this.form.inputA_1;
      if (!savedType || (!savedType.key && !savedType.value)) return;
      let typeIndex = savedType.key ? this.diff.findIndex((item) => item.key === savedType.key) : -1;
      if (typeIndex < 0) typeIndex = this.diff.findIndex((item) => item.value === savedType.value);
      if (typeIndex > -1 && typeIndex !== savedType.index) {
        this.form.inputA_1 = { ...savedType, index: typeIndex };
      }
      const savedWork = this.form.inputA_2;
      if (typeIndex < 0 || !savedWork || (!savedWork.key && !savedWork.value)) return;
      const children = this.diff[typeIndex].child;
      let workIndex = savedWork.key ? children.findIndex((item) => item.key === savedWork.key) : -1;
      if (workIndex < 0) workIndex = children.findIndex((item) => item.value === savedWork.value);
      if (workIndex < 0) {
        // 항목 명칭이 개정된 경우 번호 접두사(예: "35.")로 폴백 매칭
        const prefix = (String(savedWork.value).match(/^\d+\./) || [])[0];
        if (prefix) workIndex = children.findIndex((item) => String(item.value).startsWith(prefix));
      }
      if (workIndex < 0) {
        // 한글 접두사(예: "가. ")·공백 제거 후 폴백 매칭 (구 안전보건관리책임자 교육 하위 항목 등)
        const normalize = (s) => String(s).replace(/^[가-힣]\.\s*/, "").replace(/\s+/g, "");
        // 명칭 자체가 개정된 항목의 구명칭 → 신명칭 별칭
        const legacyAlias = { "안전관리자및안전관리전문기관종사자": "안전관리책임자및안전관리전문기관종사자" };
        let key = normalize(savedWork.value);
        if (legacyAlias[key]) key = legacyAlias[key];
        workIndex = children.findIndex((item) => normalize(item.value) === key);
      }
      if (workIndex > -1 && workIndex !== savedWork.index) {
        this.form.inputA_2 = { ...savedWork, index: workIndex };
      }
    },
    changeTarget1(selected) {
      // v-model(form.inputA_1) 갱신보다 change 이벤트가 먼저 도착할 수 있으므로, 전달된 선택값을 직접 사용한다
      const target = selected || this.form.inputA_1;
      if (!target) return;
      if (1 === this.diff[target.index].child.length) {
        this.form.inputA_15 = this.diff[target.index].child[0].textarea;
      } else {
        this.form.inputA_2 = null;
        this.form.inputA_15 = "";
      }
    },
    changeTarget2(selected) {
      const work = selected || this.form.inputA_2;
      if (!!this.form.inputA_1 && !!work) this.form.inputA_15 = this.diff[this.form.inputA_1.index].child[work.index].textarea;
    },
    onClickAddEmployee() {
      this.showPopup = true;
    },
    onClickRemoveEmployee(checkData) {
      // checkData의 배열에 있는 값과 this.employeeList의 id가 같은 것이 제거되도록 this.employeeList를 수정한다
      this.employeeList = this.employeeList.filter((item) => !checkData.includes(item.id));
    },
    handleEmployeeSelect(datas) {
      if (this.employeeList.length > 0) {
        if (datas.length > 0) {
          const adds = datas.filter((v, i) => {
            for (const emp of this.employeeList) {
              if (emp.id === v.id) {
                return false;
              }
            }
            return true
          });

          this.employeeList.push(...adds.map((item) => {
            return {
              id: item.id,
              employee_id: item.employee_id,
              com_name: item.com_name ? item.com_name : item.company.com_name,
              field_name: item.field_name ? item.field_name : item.fields.length > 0 ? item.fields[0].field_name : "",
              employment_type: item.employment_type,
              full_name: item.full_name,
            };
          }));
        }
      } else {
        this.employeeList = datas.map((item) => {
          return {
            id: item.id,
            employee_id: item.employee_id,
            com_name: item.com_name ? item.com_name : item.company.com_name,
            field_name: item.field_name ? item.field_name : item.fields.length > 0 ? item.fields[0].field_name : "",
            employment_type: item.employment_type,
            full_name: item.full_name,
          };
        });
      }
      const newList = JSON.parse(JSON.stringify(this.employeeList))
      this.employeeList = newList.filter((v, i) => newList.indexOf(v).id === i.id);

      this.form.participants_attended = this.employeeList.length
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
  word-break: keep-all;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
